/* eslint-disable no-param-reassign */
import axios from 'axios';
import { base } from '../../config/config';

class Result {
  constructor(movies, pages, totalRes) {
    this.movies = movies;
    this.pages = pages;
    this.totalRes = totalRes;
  }
}

export default {
  state: {
    paramsData: {
      movies: [],
      pages: '',
      totalRes: '',
      params: null,
      page: null,
    },
  },
  mutations: {
    setParamsResults(state, { result, params }) {
      result.movies.forEach((element) => {
        state.paramsData.movies.push(element);
      });
      state.paramsData.pages = result.pages;
      state.paramsData.totalRes = result.totalRes;
      state.paramsData.params = params;
      state.paramsData.page += 1;
    },
    resetParamsResults(state) {
      state.paramsData.movies = [];
      state.paramsData.pages = '';
      state.paramsData.totalRes = '';
      state.paramsData.params = null;
      state.paramsData.page = null;
    },
  },
  actions: {
    async getParamResults({ commit, state }, { params }) {
      commit('clearError');
      commit('setLoading', true);

      let actor = '';

      // console.log('getParamResults -> params', params);


      if (params.actor !== '') {
        try {
          const url = `https://api.themoviedb.org/3/search/person?api_key=${
            base.key
          }&${base.language}&query=${
            params.actor
          }&page=1&include_adult=false&region=${params.country}`;

          const response = await axios.get(url);
          actor = response.data.results[0].id;
        } catch (error) {
          commit('setError', `Darsteller nicht gefunden: ${error.message}`);
        }
      }

      try {
        const url = `https://api.themoviedb.org/3/discover/movie?api_key=${
          base.key
        }&${base.language}&region=${params.country}&sort_by=${
          params.sort
        }&include_adult=false&include_video=false&page=${
          state.paramsData.page === null ? 1 : state.paramsData.page + 1
        }&primary_release_date.gte=${params.yearFrom}&primary_release_date.lte=${
          params.yearTill
        }&vote_average.gte=${params.rate}&with_genres=${
          params.genere
        }&with_people=${actor}`;

        // console.log('ParamSearchUrl:', url);

        const response = await axios.get(url);
        const { data } = response;

        const result = new Result(
          data.results,
          data.total_pages,
          data.total_results,
        );

        commit('setLoading', false);
        commit('setParamsResults', { result, params });
      } catch (error) {
        commit('setError', `Uups! Da is was schief gelaufen: ${error.message}`);
        commit('setLoading', false);
      }
    },
  },
  getters: {
    getParamsTotalRes(state) {
      return state.paramsData.totalRes;
    },
  },
};
